function showCustomConfirmation(message) {
  return new Promise((resolve) => {
    const popup = document.getElementById('custom-popup');
    const messageBox = document.getElementById('custom-popup-message');
    const yesBtn = document.getElementById('popup-yes');
    const noBtn = document.getElementById('popup-no');

    // Allow HTML inside the message
    messageBox.innerHTML = message;
    popup.classList.remove('hidden');

    const cleanup = () => {
      popup.classList.add('hidden');
      yesBtn.removeEventListener('click', onYes);
      noBtn.removeEventListener('click', onNo);
    };

    const onYes = () => {
      cleanup();
      resolve(true);
    };

    const onNo = () => {
      cleanup();
      resolve(false);
    };

    yesBtn.addEventListener('click', onYes);
    noBtn.addEventListener('click', onNo);
  });
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.setSubmitButtonLoading(true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Accept'] = 'application/json';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement?.(document.activeElement);
      }
      config.body = formData;

      try {
        const shouldContinue = await this.confirmProductCompatibilityIfNeeded();
        if (!shouldContinue) return;

        const response = await fetch(`${routes.cart_add_url}`, config);
        const parsedState = await this.parseCartResponse(response);

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(parsedState) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(parsedState);
        }
      } catch (error) {
        this.error = true;
        console.error('Product form add to cart failed:', error);
        this.handleErrorMessage(this.getReadableErrorMessage(error));
      } finally {
        this.setSubmitButtonLoading(false);
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      }
    }

    async confirmProductCompatibilityIfNeeded() {
      const isSeedProduct = window.productFlags?.isSeedProduct;
      const isPreEmergentProduct = window.productFlags?.isPreEmergentProduct;

      if (!isSeedProduct && !isPreEmergentProduct) return true;

      let cart;
      try {
        const cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!cartResponse.ok) return true;
        cart = await cartResponse.json();
      } catch (error) {
        console.warn('Could not check product compatibility before add to cart:', error);
        return true;
      }

      let showConfirmation = false;
      let conflictMessage = '';

      cart.items.forEach(item => {
        const itemTitle = item.title?.toLowerCase() || '';
        const itemType = item.product_type?.toLowerCase() || '';

        if (isSeedProduct && itemTitle.includes('pre-emergent')) {
          showConfirmation = true;
          conflictMessage = `Your cart contains a Pre-Emergent. We do not recommend applying Pre-Emergents and Grass Seed at the same time. The seed may not grow. Check out our <a href="/products/starter-fertilizer-15-20-10" target="_blank">Starter Fertilizer</a>, which will boost seed growth. Do you still want to add this Grass Seed?`;
        }

        if (isPreEmergentProduct && itemType === 'seed') {
          showConfirmation = true;
          conflictMessage = `Your cart contains Grass Seed. We do not recommend applying Pre-Emergents and Grass Seed at the same time. The seed may not grow. Check out our <a href="/products/starter-fertilizer-15-20-10" target="_blank">Starter Fertilizer</a>, which will boost seed growth. Do you still want to add this Pre-emergent?`;
        }
      });

      if (!showConfirmation) return true;
      return showCustomConfirmation(conflictMessage);
    }

    async parseCartResponse(response) {
      let parsedState = null;
      try {
        parsedState = await response.json();
      } catch (jsonError) {
        if (!response.ok) {
          throw new Error('We could not add this item to your cart. Please try again.');
        }
      }

      if (!response.ok || parsedState?.status) {
        const message = parsedState?.description || parsedState?.message || parsedState?.errors || 'We could not add this item to your cart. Please try again.';
        throw new Error(Array.isArray(message) ? message.join(' ') : String(message));
      }

      return parsedState;
    }

    getReadableErrorMessage(error) {
      const fallback = 'Something went wrong. Please try again or contact us for help.';
      const message = typeof error === 'string' ? error : error?.message;
      if (!message) return fallback;

      if (/sold out|not enough|unavailable|cannot be added|not available/i.test(message)) {
        return 'This item is currently unavailable or there is not enough inventory for the quantity selected.';
      }

      return message;
    }

    setSubmitButtonLoading(isLoading) {
      if (!this.submitButton) return;

      const spinner = this.querySelector('.loading-overlay__spinner');
      if (isLoading) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        spinner?.classList.remove('hidden');
      } else {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        spinner?.classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
